/**
 * Created by Omar Alejandro Leonor Avalos on 2017-09-11.
 * Logout modal
 */
import React, { Component } from 'react';
import { FlatButton, Dialog } from 'material-ui';
import { logout } from '../security';

class Logout extends Component {
    render() {
        const { open, onCancel } = this.props;
        const actions = [
            <FlatButton
                label="Cancelar"
                primary
                onClick={() => onCancel()}
            />,
            < FlatButton
                label="Cerrar Sesión"
                primary
                keyboardFocused
                onClick={() => logout()}
            />
        ];

        return (
            <Dialog
                title="Cerrar Sesión"
                actions={actions}
                modal={false}
                open={open}
                onRequestClose={() => { }}
            >
                ¿Está seguro de cerrar la sesión?
            </Dialog>
        );
    }
}

export default Logout;



// WEBPACK FOOTER //
// ./modals/logout.js